
import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

const Contact = () => {
  useEffect(() => {
    // FAQ Toggle functionality
    const faqItems = document.querySelectorAll('.faq-item');

    faqItems.forEach(item => {
      const question = item.querySelector('.faq-question');
      const answer = item.querySelector('.faq-answer');
      const icon = item.querySelector('.faq-toggle i');

      question.addEventListener('click', () => {
        // Close all other items
        faqItems.forEach(otherItem => {
          if (otherItem !== item) {
            const otherAnswer = otherItem.querySelector('.faq-answer');
            const otherIcon = otherItem.querySelector('.faq-toggle i');

            otherAnswer.classList.add('hidden');
            otherIcon.classList.remove('fa-minus');
            otherIcon.classList.add('fa-plus');
          }
        });

        // Toggle current item
        const isOpen = !answer.classList.contains('hidden');

        if (isOpen) {
          answer.classList.add('hidden');
          icon.classList.remove('fa-minus');
          icon.classList.add('fa-plus');
        } else {
          answer.classList.remove('hidden');
          icon.classList.remove('fa-plus');
          icon.classList.add('fa-minus');
        }
      });
    });
  }, []);

  return (
    <>
      {/* Page Header */}
      <section className="relative py-24 bg-cover bg-center bg-no-repeat" style={{ backgroundImage: "url('https://images.unsplash.com/photo-1423666639041-f56000c27a9a?auto=format&fit=crop&w=1920&q=80')" }}>
        {/* Overlay */}
        <div className="absolute inset-0 bg-black bg-opacity-50"></div>

        {/* Content */}
        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center text-white">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-4">Contact Us</h1>
            <div className="flex items-center justify-center space-x-2 text-lg">
              <Link to="/" className="hover:text-primary-300 transition-colors">Home</Link>
              <i className="fas fa-chevron-right text-sm"></i>
              <span className="text-primary-300">Contact</span>
            </div>
          </div>
        </div>
      </section>

      {/* Ad Banner */}
      <section className="py-16 lg:py-24 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="ad-banner text-center mb-12">
            <iframe 
              border="0" 
              src="https://www.trip.com/partners/ad/SB5794672?Allianceid=6648580&SID=228113005&trip_sub1=" 
              frameborder="0" 
              scrolling="no" 
              title="Trip.com Advertisement" 
              style={{width: '300px', height: '250px'}}
            ></iframe>
          </div>
        </div>
      </section>

      {/* Contact Info Section */}
      <section className="py-16 lg:py-24 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">Get in Touch</h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">We're here to help with any questions you may have</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="bg-gray-50 rounded-xl p-8 text-center hover:shadow-lg transition-shadow duration-300">
              <div className="w-16 h-16 bg-primary-500 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="fas fa-map-marker-alt text-white text-xl"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">Our Location</h3>
              <p className="text-gray-600">Business Bay, Dubai<br />United Arab Emirates</p>
            </div>

            <div className="bg-gray-50 rounded-xl p-8 text-center hover:shadow-lg transition-shadow duration-300">
              <div className="w-16 h-16 bg-primary-500 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="fas fa-phone-alt text-white text-xl"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">Phone Number</h3>
              <p className="text-gray-600">
                <a href="tel:+97144001234" className="hover:text-primary-500 transition-colors">+971 4 400 1234</a><br />
                <a href="tel:+971501234567" className="hover:text-primary-500 transition-colors">+971 50 123 4567</a>
              </p>
            </div>

            <div className="bg-gray-50 rounded-xl p-8 text-center hover:shadow-lg transition-shadow duration-300">
              <div className="w-16 h-16 bg-primary-500 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="fas fa-envelope text-white text-xl"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">Email Address</h3>
              <p className="text-gray-600">
                <a href="mailto:info@jobsdriver.xyz" className="hover:text-primary-500 transition-colors">info@jobsdriver.xyz</a><br />
                <a href="mailto:support@jobsdriver.xyz" className="hover:text-primary-500 transition-colors">support@jobsdriver.xyz</a>
              </p>
            </div>

            <div className="bg-gray-50 rounded-xl p-8 text-center hover:shadow-lg transition-shadow duration-300">
              <div className="w-16 h-16 bg-primary-500 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="fas fa-clock text-white text-xl"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">Working Hours</h3>
              <p className="text-gray-600">Monday - Friday: 9:00 AM - 6:00 PM<br />Saturday: 10:00 AM - 2:00 PM</p>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Form Section */}
      <section className="py-16 lg:py-24 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div className="bg-white rounded-2xl shadow-xl p-8 lg:p-12">
              <div className="mb-8">
                <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">Send Us a Message</h2>
                <p className="text-lg text-gray-600">Fill out the form below and we'll get back to you as soon as possible</p>
              </div>

              <form className="space-y-6">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div>
                    <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-2">Full Name</label>
                    <input type="text" id="name" name="name" placeholder="Your full name" required
                           className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-primary-500 transition-colors" />
                  </div>
                  <div>
                    <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2">Email Address</label>
                    <input type="email" id="email" name="email" placeholder="Your email address" required
                           className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-primary-500 transition-colors" />
                  </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div>
                    <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-2">Phone Number</label>
                    <input type="tel" id="phone" name="phone" placeholder="Your phone number"
                           className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-primary-500 transition-colors" />
                  </div>
                  <div>
                    <label htmlFor="subject" className="block text-sm font-medium text-gray-700 mb-2">Subject</label>
                    <input type="text" id="subject" name="subject" placeholder="Message subject" required
                           className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-primary-500 transition-colors" />
                  </div>
                </div>

                <div>
                  <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-2">Message</label>
                  <textarea id="message" name="message" rows="5" placeholder="Your message" required
                            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-primary-500 transition-colors resize-vertical"></textarea>
                </div>

                <div className="flex items-start">
                  <div className="flex items-center h-5">
                    <input type="checkbox" name="privacy_policy" required
                           className="w-4 h-4 text-primary-600 bg-gray-100 border-gray-300 rounded focus:ring-primary-500 focus:ring-2" />
                  </div>
                  <div className="ml-3 text-sm">
                    <label htmlFor="privacy_policy" className="text-gray-700">
                      I agree to the <a href="/privacy-policy" className="text-primary-600 hover:text-primary-700 underline">Privacy Policy</a> and consent to the processing of my personal data
                    </label>
                  </div>
                </div>

                <button type="submit" className="w-full bg-primary-600 hover:bg-primary-700 text-white font-semibold py-3 px-6 rounded-lg transition-colors duration-200 transform hover:scale-105">
                  Send Message
                </button>
              </form>
            </div>

            <div className="hidden lg:block">
              <img src="https://images.unsplash.com/photo-1600880292089-90a7e086ee0c?auto=format&fit=crop&w=600&q=80"
                   alt="Contact JobsDriver"
                   className="w-full h-full object-cover rounded-2xl shadow-xl" />
            </div>
          </div>
        </div>
      </section>

      {/* Map Section */}
      <section className="py-16 lg:py-24 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">Our Location</h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">Find us in Business Bay, Dubai</p>
          </div>
        </div>
        <div className="w-full">
          <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d14440.421211562546!2d55.26442698715819!3d25.18511249999999!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e5f682def25f457%3A0x3dd4c4097970950e!2sBusiness%20Bay%20-%20Dubai!5e0!3m2!1sen!2sae!4v1626789456789!5m2!1sen!2sae"
                  width="100%"
                  height="450"
                  style={{ border: 0 }}
                  allowFullScreen=""
                  title="JobsDriver Location Map"
                  loading="lazy"
                  className="w-full"></iframe>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="py-16 lg:py-24 bg-gray-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">Frequently Asked Questions</h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">Find answers to common questions about JobsDriver</p>
          </div>

          <div className="space-y-4">
            <div className="faq-item bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
              <div className="faq-question flex items-center justify-between p-6 cursor-pointer hover:bg-gray-50 transition-colors">
                <h3 className="text-lg font-semibold text-gray-900 pr-4">Is it free to create an account on JobsDriver?</h3>
                <span className="faq-toggle flex-shrink-0 w-8 h-8 bg-primary-100 rounded-full flex items-center justify-center">
                  <i className="fas fa-plus text-primary-600 text-sm"></i>
                </span>
              </div>
              <div className="faq-answer hidden px-6 pb-6">
                <p className="text-gray-600 leading-relaxed">Yes, creating a job seeker account on JobsDriver is completely free. You can browse jobs, save favorites, and apply to positions without any cost.</p>
              </div>
            </div>


            <div className="faq-item bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
              <div className="faq-question flex items-center justify-between p-6 cursor-pointer hover:bg-gray-50 transition-colors">
                <h3 className="text-lg font-semibold text-gray-900 pr-4">How can I make my job application stand out?</h3>
                <span className="faq-toggle flex-shrink-0 w-8 h-8 bg-primary-100 rounded-full flex items-center justify-center">
                  <i className="fas fa-plus text-primary-600 text-sm"></i>
                </span>
              </div>
              <div className="faq-answer hidden px-6 pb-6">
                <p className="text-gray-600 leading-relaxed">To make your application stand out, ensure your profile is complete with relevant skills and experience, tailor your resume for each application, and include a personalized cover letter that highlights why you're a good fit for the position.</p>
              </div>
            </div>

            <div className="faq-item bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
              <div className="faq-question flex items-center justify-between p-6 cursor-pointer hover:bg-gray-50 transition-colors">
                <h3 className="text-lg font-semibold text-gray-900 pr-4">What should I do if I forgot my password?</h3>
                <span className="faq-toggle flex-shrink-0 w-8 h-8 bg-primary-100 rounded-full flex items-center justify-center">
                  <i className="fas fa-plus text-primary-600 text-sm"></i>
                </span>
              </div>
              <div className="faq-answer hidden px-6 pb-6">
                <p className="text-gray-600 leading-relaxed">If you forgot your password, click on the "Forgot Password" link on the login page. You'll receive an email with instructions to reset your password.</p>
              </div>
            </div>

            <div className="faq-item bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
              <div className="faq-question flex items-center justify-between p-6 cursor-pointer hover:bg-gray-50 transition-colors">
                <h3 className="text-lg font-semibold text-gray-900 pr-4">How can I get job alerts for new positions?</h3>
                <span className="faq-toggle flex-shrink-0 w-8 h-8 bg-primary-100 rounded-full flex items-center justify-center">
                  <i className="fas fa-plus text-primary-600 text-sm"></i>
                </span>
              </div>
              <div className="faq-answer hidden px-6 pb-6">
                <p className="text-gray-600 leading-relaxed">You can set up job alerts by creating an account and configuring your job preferences. You'll receive email notifications when new jobs matching your criteria are posted.</p>
              </div>
            </div>
          </div>

          {/* Ad Banner */}
          <div className="text-center mt-12">
            <iframe 
              border="0" 
              src="https://www.trip.com/partners/ad/SB5794672?Allianceid=6648580&SID=228113005&trip_sub1=" 
              style={{width:'300px', height:'250px'}} 
              frameBorder="0" 
              scrolling="no" 
              id="SB5794672"
              title="Trip.com Advertisement"
            ></iframe>
          </div>

          <div className="text-center mt-12">
            <Link to="/faq" className="inline-flex items-center px-8 py-3 border-2 border-primary-600 text-primary-600 hover:bg-primary-600 hover:text-white font-semibold rounded-lg transition-all duration-200 transform hover:scale-105">
              View All FAQs
            </Link>
          </div>
        </div>
      </section>
    </>
  );
};

export default Contact;
